import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { MtgLogo } from "@/components/MtgLogo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); }
    catch { /* intentionally silent: do not reveal whether the email exists */ }
    setLoading(false);
    setSent(true);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-8">
      <div className="w-full max-w-sm">
        <MtgLogo withText className="h-6 w-6" />
        <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          {sent ? (
            <div className="text-center">
              <MailCheck className="mx-auto h-10 w-10 text-teal-600" />
              <h1 className="mt-3 font-heading text-xl font-bold text-slate-900">Check your email</h1>
              <p className="mt-2 text-sm text-slate-500">If that email is registered, a reset link has been sent. It expires in 1 hour.</p>
            </div>
          ) : (
            <form onSubmit={submit}>
              <h1 className="font-heading text-xl font-bold text-slate-900">Reset password</h1>
              <p className="mt-1 text-sm text-slate-500">Enter your account email and we'll send a reset link.</p>
              <div className="mt-5">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" className="mt-1.5" />
              </div>
              <Button type="submit" disabled={loading} data-testid="forgot-submit-button" className="mt-5 w-full bg-teal-600 hover:bg-teal-700">
                {loading ? "Sending..." : "Send reset link"}
              </Button>
            </form>
          )}
          <Link to="/login" className="mt-5 inline-flex items-center gap-1.5 text-sm text-teal-700 hover:underline" data-testid="back-to-login-link">
            <ArrowLeft className="h-4 w-4" /> Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
